/* eslint-disable max-len */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IExpedient } from 'bg-server/src/components/api/v1/expedient/types';

import { IUpdateAttachmentRequest } from 'src/interfaces';
import { attachmentService } from 'src/services/attachment';
import { expedientService } from 'src/services/expedient';

import { setLastActionStatus, setLoadingStatus } from '../app';
import { ICoreState } from '../types';

export const setSelectedExpedient = createAsyncThunk<IExpedient, string, { state: ICoreState }>('expedient/setSelectedExpedient', async (id, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }
        dispatch(setLoadingStatus(true));
        const expedient = await expedientService.getExpedientById(id);
        dispatch(setLastActionStatus('expedientSelected'));
        dispatch(setLoadingStatus(false));
        return expedient;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        dispatch(setLastActionStatus('expedientSelectError'));
        throw error;
    }
});

export const uploadExpedientAttachmentById = createAsyncThunk<{ selectedExpedient: IExpedient }, { expedientId:string, file: File, attachmentId: string }, { state: ICoreState }>('expedient/uploadAttachmentById', async (data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }
        const { file, attachmentId, expedientId } = data;
        const updatedExpedient = await attachmentService.uploadExpedientAttachmentById(file, expedientId, attachmentId);

        const result = {
            selectedExpedient: updatedExpedient,
        };
        return result;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});

export const manualSignExpedientAttachment = createAsyncThunk<{ selectedExpedient: IExpedient }, { expedientId:string, file: File, attachmentId: string }, { state: ICoreState }>('expedient/manualSignAttachment', async (data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }
        const { file, attachmentId, expedientId } = data;
        const updatedExpedient = await attachmentService.manualSignExpedientAttachment(file, expedientId, attachmentId);

        const result = {
            selectedExpedient: updatedExpedient,
        };
        return result;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});

export const manualSignExpedientAttachmentByAjuntament = createAsyncThunk<{ selectedExpedient: IExpedient }, { expedientId:string, file: File, attachmentId: string }, { state: ICoreState }>('expedient/manualSignAttachmentByAjuntament', async (data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }
        const { file, attachmentId, expedientId } = data;
        const updatedExpedient = await attachmentService.manualSignExpedientAttachmentByAjuntament(file, expedientId, attachmentId);

        const result = {
            selectedExpedient: updatedExpedient,
        };
        return result;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});

// eslint-disable-next-line max-len
export const deleteExpedientAttachment = createAsyncThunk<{ selectedExpedient: IExpedient }, { expedientId:string, attachmentId: string }, { state: ICoreState }>('expedient/deleteAttachment', async (data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }
        const { attachmentId, expedientId } = data;
        const updatedExpedient = await attachmentService.deleteExpedientAttachment(expedientId, attachmentId);
        const result = {
            selectedExpedient: updatedExpedient,
        };
        return result;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});

export const updateExpedientAttachment = createAsyncThunk<{ selectedExpedient: IExpedient }, { expedientId:string, attachmentId: string, body: IUpdateAttachmentRequest }, { state: ICoreState }>('expedient/updateAttachment', async (data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }
        const { attachmentId, expedientId, body } = data;
        const updatedExpedient = await attachmentService.updateExpedientAttachment(expedientId, attachmentId, body);
        const result = {
            selectedExpedient: updatedExpedient,
        };
        dispatch(setLastActionStatus('expedientAttachmentUpdated'));
        return result;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});
